import {AfterViewInit, DestroyRef, Directive, ElementRef, inject, signal, WritableSignal} from "@angular/core";
import {fromEvent, Observable, PartialObserver, switchMap, tap} from "rxjs";
import {onEach} from '../utils/observable-utils';

/**
 * Directive to add "touched" class to an element while it is touched
 */
@Directive({
    selector: "[woa-touchable]"
})
export class TouchableDirective implements AfterViewInit {
    private destroyRef: DestroyRef = inject(DestroyRef);
    private element: ElementRef = inject(ElementRef);

    public readonly touched: WritableSignal<boolean> = signal<boolean>(false);

    ngAfterViewInit(): void {
        this.element.nativeElement.classList.add("touchable");

        const touchstart$: Observable<TouchEvent> = fromEvent(this.element.nativeElement, "touchstart", {passive: true});
        const touchend$: Observable<TouchEvent> = fromEvent(this.element.nativeElement, "touchend", {passive: true});
        const mousedown$: Observable<TouchEvent> = fromEvent(this.element.nativeElement, "mousedown", {passive: true});
        const mouseup$: Observable<TouchEvent> = fromEvent(this.element.nativeElement, "mouseup", {passive: true});

        onEach(touchstart$.pipe(
            tap(() => {
                this.element.nativeElement.classList.add("touched");
                this.touched.set(true);
            }),
            switchMap(() => touchend$.pipe(
                tap(() => {
                    this.element.nativeElement.classList.remove("touched");
                    this.touched.set(false);
                })
            )),
        ), {} as PartialObserver<TouchEvent>, this.destroyRef);

        onEach(mousedown$.pipe(
            tap(() => {
                this.element.nativeElement.classList.add("touched");
                this.touched.set(true);
            }),
            switchMap(() => mouseup$.pipe(
                tap(() => {
                    this.element.nativeElement.classList.remove("touched");
                    this.touched.set(false);
                })
            )),
        ), {} as PartialObserver<TouchEvent>, this.destroyRef);
    }
}
